import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '../icon/icon';
import { SkyviewContext } from '../skyview/skyview-state';
import { Tooltip } from '../tooltip/tooltip';
import { RoundButton } from './round-button';

/** Shows the whole scene, as the toolbar's focus tool where the orientation cube isn't shown. */
const FocusSceneButton = () => {
  const { t } = useTranslation();
  const { skyview } = React.useContext(SkyviewContext);

  return (
    <Tooltip
      content={t('focus.tooltip.text', { ns: 'skyviewToolbar' })}
      mainAxisOffset={10}
      placement="bottom"
      title={t('focus.tooltip.title', { ns: 'skyviewToolbar' })}
    >
      <RoundButton
        aria-label={t('focus.tooltip.title', { ns: 'skyviewToolbar' })}
        type="button"
        onClick={() => skyview.focusOnGeodata()}
      >
        <Icon icon={['fal', 'expand']} />
      </RoundButton>
    </Tooltip>
  );
};

export { FocusSceneButton };
